module.exports = __webpack_public_path__ + "media/images/sustainability-b0338ce860afef7ab16e40f2110f4176.svg";